import { render, staticRenderFns } from "./CreateClientButton.vue?vue&type=template&id=5cd84a87&"
import script from "./CreateClientButton.vue?vue&type=script&lang=ts&"
export * from "./CreateClientButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports